import { useEffect, useRef, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { analyticsService } from '../services/analyticsService';

export function usePageView() {
  const location = useLocation();
  const trackedRef = useRef('');

  useEffect(() => {
    const key = location.pathname + location.search;

    // Skip tracking for admin pages
    if (location.pathname.startsWith('/admin')) return;

    if (trackedRef.current === key) return;
    trackedRef.current = key;

    analyticsService.trackPageView(location.pathname, document.referrer);
  }, [location.pathname, location.search]);
}

export function useDownloadTracker() {
  const track = useCallback((source, section) => {
    analyticsService.trackDownloadClick(source, section);
  }, []);
  return track;
}